<template>
  <div class="menu-list">
    <div class="cell-container"
         v-for="(list, index) in cellData"
         :key="'cell-' + index"
    >
      <ym-cell class="cell-container-list"
               :title="item.title"
               v-for="(item, itemKey) in list"
               :key="'item-' + itemKey"
               is-link
               :to="{ name: item.name }"
      >
        <span v-if="item.name === 'MyInformation' && infoNum > 0"
              class="info-tips"
        >{{ infoNum }}条新消息</span>
        <template #icon>
          <ym-img class="ym-cell-icon"
                  :src="require(`@/assets/img/user_center/icon_list_${item.icon}.png`)"
          />
        </template>

      </ym-cell>
    </div>
  </div>
</template>

<script>
  import { Cell } from '@ymba/ym-ui';

  export default {
    name: 'MenuList',
    components: {
      'ym-cell': Cell,
    },
    props: {
      cellData: {
        type: Array,
      },
      infoNum: {
        type: Number,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .menu-list {
    display: flex;
    justify-content: center;
  }

  .cell-container {
    width: 690px;
    margin: @size-base @size-base 0;
    border-radius: @border-radius-extra-large;
    background: @color-white;
    overflow: hidden;
    /deep/ .ym-cell-text {
      color: #333;
      font-size: @font-size-base;
    }
  }

  .ym-cell-icon {
    width: @size-medium;
    height: @size-medium;
    margin-right: 16px;
  }

  .info-tips {
    font-size: @font-size-small;
    color: @color-text-lighter;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      width: 14px;
      height: 14px;
      background: @color-highlight;
      border-radius: @border-radius-round;
      left: -@size-small;
      top: 10px;
    }
  }
</style>
